const NavbarItem = require('../NavbarItem');

class NavbarItemDetailed extends NavbarItem {
  constructor(container) {
    super(container);
    this.hasParent = false;
    this.$submenuNavItems = [];
    this.$submenuTitle = '';
    this.$pageInfo = jQuery(`.mad-navbar-page-info[data-page-info-id="${this.menuId}"]`); // Reference to page info
    this.isFeatured = this.$container.hasClass('mad-navbar__submenu-item--featured');
    if (this.hasSubmenu) {
      this.$submenuTitle = this.$submenu.find('.mad-navbar__submenu-title').first()
    }
    this.hideAllNavItems = null;
    this.setMegaRow = null;
  }

  show(activationCallback) {
    super.show(activationCallback);
    if (this.hasSubmenu) this.$submenu.show();
    this.showPageInfo();
    activationCallback();
  }

  hide(exception = null, hideFirstLevel = false) {
    clearTimeout(this._hoverTimeout);
    const isException = this == exception;
    const childIsException = this.childIsException(exception);
    var result = !isException && !childIsException;
    if (!isException && !childIsException) {
      if (this.hasParent || hideFirstLevel) this.$submenu.hide();
      super.hide(exception);
    }
    for (const submenuNavItem of this.$submenuNavItems) {
      submenuNavItem.hide(exception);
    }
    if (!isException && !childIsException) {
      this.hidePageInfo();
    }
  }

  childIsException(exception) {
    for (const childNavItem of this.$submenuNavItems) {
      if (childNavItem == exception || childNavItem.childIsException(exception)) return true;
    }
    return false;
  }

  initSubmenuEvents(siblings = []) {
    this._hoverTimeout = null;

    jQuery(this.$container).on('mouseenter', (event) => {
      const anySiblingSubmenuActive = siblings.some(s => s.isActive && s.hasSubmenu);
      let delay;
      if (anySiblingSubmenuActive && this.hasSubmenu) delay = 100;
      else if (anySiblingSubmenuActive || this.hasSubmenu) delay = 120;
      else delay = 80;

      this._hoverTimeout = setTimeout(() => {
        this.hideAllNavItems(this);
        this.deactivateSubmenuNavItems();
        this.activate();
        if (this.hasSubmenu) {
          this.$submenu.show();
        }
        if (!this.isFeatured) this.showPageInfo();
      }, delay);
    });

    jQuery(this.$container).on('mouseleave', () => {
      clearTimeout(this._hoverTimeout);
    });

    this.initSubmenuTitle();
  }

  initSubmenuTitle() {
    jQuery(this.$submenuTitle).on('mouseenter', (event) => {
      this.hideSubmenuNavItems();
      this.showPageInfo();
    })
  }

  deactivateSubmenuNavItems() {
    for (const submenuNavItem of this.$submenuNavItems) {
      submenuNavItem.deactivate();
    }
  }

  hideSubmenuNavItems() {
    for (const submenuNavItem of this.$submenuNavItems) {
      submenuNavItem.hide();
    }
  }

  showPageInfo() {
    gsap.killTweensOf('.mad-navbar-page-info__image-container img, .mad-navbar-page-info__content');

    // Clean up any card left absolutely positioned by a rapidly-interrupted prior transition
    jQuery('.mad-navbar-page-info--out')
      .css({ position: '', top: '', left: '', width: '' })
      .hide()
      .removeClass('mad-navbar-page-info--out');

    const $current = jQuery('.mad-navbar-page-info:visible');
    const $next = this.$pageInfo;

    if ($current.length && $current[0] !== $next[0]) {
      const $currentImg = $current.find('.mad-navbar-page-info__image-container img');
      const $currentContent = $current.find('.mad-navbar-page-info__content');
      const $nextImg = $next.find('.mad-navbar-page-info__image-container img');
      const $nextContent = $next.find('.mad-navbar-page-info__content');
      // jQuery sets must be merged with .add() – gsap does not unwrap jQuery objects nested in an array
      const $currentTargets = $currentImg.add($currentContent);

      // Pull old card out of flex flow so the new one can fill its place immediately,
      // enabling a true crossfade (both images animated at the same time)
      const pos = $current.position();
      $current.addClass('mad-navbar-page-info--out')
        .css({ position: 'absolute', top: pos.top, left: pos.left, width: $current.outerWidth() });
      $next.show();

      // Fade out old image
      gsap.to($currentTargets, {
        opacity: 0,
        duration: 0.25,
        onComplete: () => {
          gsap.set($currentTargets, { clearProps: 'opacity' });
          $current.removeClass('mad-navbar-page-info--out')
            .css({ position: '', top: '', left: '', width: '' })
            .hide();
        }
      });

      // Fade in new image with overlap (starts as old begins fading)
      gsap.fromTo($nextImg, { opacity: 0 }, { opacity: 1, duration: 0.45 });
      gsap.fromTo($nextContent, { opacity: 0 }, { opacity: 1, duration: 0.33, delay: 0.06 });
    } else {
      // Bug fix: handles "no visible card" AND "same card at partial opacity"
      // gsap.to animates from current opacity → 1, recovering from any stuck state
      $next.show();
      gsap.to($next.find('.mad-navbar-page-info__image-container img'), { opacity: 1, duration: 0.35 });
      gsap.to($next.find('.mad-navbar-page-info__content'), { opacity: 1, duration: 0.28, delay: 0.07 });
    }

    this.setMegaRow();
  }

  hidePageInfo() {
    const $img = this.$pageInfo.find('.mad-navbar-page-info__image-container img');
    const $content = this.$pageInfo.find('.mad-navbar-page-info__content');
    const $targets = $img.add($content);

    if (!$targets.length) {
      this.$pageInfo.hide();
      return;
    }

    gsap.killTweensOf($targets);
    gsap.to($targets, {
      opacity: 0,
      duration: 0.15,
      onComplete: () => {
        gsap.set($targets, { clearProps: 'opacity' });
        this.$pageInfo.hide();
      }
    });
  }
}

module.exports = NavbarItemDetailed;
